import { Component } from '@angular/core';

@Component({ standalone:false,
  selector: 'app-root',
  templateUrl: './reporting-system.component.html',
  styleUrls: ['./reporting-system.component.scss'],
})
export class ReportingSystemComponent {
  title = 'project-x-reports';
}
